// import React, { useState,useEffect } from "react";
// import "../style/create.css";
// import { postWithoutTokenAPI } from "../util/Api";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import 'react-toastify/dist/ReactToastify.css';
// import { useSelector } from 'react-redux';

// const CreateAccount = () => {
//     const navigate = useNavigate();
//     const [phonenumber, setPhonenumber] = useState("");
//     const [termsAccepted, setTermsAccepted] = useState(false);
//     const [error, setError] = useState("");
//     const login = useSelector((state) => state.auth?.auth?.access_token);

//     // Regex for validating phone number format (10-15 digits)
//     const validatePhoneNumber = (number) => /^[0-9]{10,15}$/.test(number);

//     const handleSubmit = async () => {
//         setError(""); // Clear any previous errors

//         // Check if phone number is provided
//         if (!phonenumber) {
//             setError("Phone number is required");
//             return;
//         }

//         // Validate the phone number format
//         if (!validatePhoneNumber(phonenumber)) {
//             setError("Please enter a valid phone number");
//             return;
//         }

//         // Check if the terms and conditions are accepted
//         if (!termsAccepted) {
//             setError("You must accept the terms and conditions");
//             return;
//         }

//         try {
//             const response = await postWithoutTokenAPI("/auth/otpsend", {
//                 phone_number: phonenumber,
//             });

//             if (response.statusCode === 200) {
//                 toast.success("OTP sent successfully!");
//                 setTimeout(() => {
//                     navigate("/Verify", {
//                         state: {
//                             phone_number: phonenumber,
//                             fromForgotPassword: false,
//                         },
//                     });
//                 }, 2000);
//             } else {
//                 setError(response.message || "Request failed.");
//             }
//         } catch (err) {
//             setError("An error occurred. Please try again.");
//         }
//     };
//     useEffect(() => {
//         if (login) {
//             navigate('/user'); // or any page you want
//         }
//     }, [login, navigate]);

//     return (
//         <>
//             {!login &&
//                 <div className="auth-box">
//                     <ToastContainer autoClose={10000} />
//                     <h2 className="auth-title">Create Account</h2>
//                     <div className="auth-field">
//                         <input
//                             className="auth-input"
//                             type="text"
//                             placeholder="Enter your phone number"
//                             value={phonenumber}
//                             onChange={(e) => setPhonenumber(e.target.value)}
//                         />
//                     </div>
//                     <div className="auth-links">
//                         <div className="auth-remember-section">
//                             <input
//                                 type="checkbox"
//                                 id="remember"
//                                 checked={termsAccepted}
//                                 onChange={(e) => setTermsAccepted(e.target.checked)}
//                             />
//                             <label htmlFor="remember" className="auth-remember-label">
//                                 I accept all<a href='/terms' target="_blank" rel="noopener noreferrer"> Terms & Conditions</a>
//                             </label>
//                         </div>
//                     </div>
//                     {error && <div className="auth-error">{error}</div>}
//                     <button className="auth-button" onClick={handleSubmit}>
//                         Create Account
//                     </button>
//                     <div className="auth-signup-link">
//                         <span>Already have an account?</span>
//                         <a href="/login">Login</a>
//                     </div>
//                 </div>
//             }
//         </>
//     );
// };

// export default CreateAccount;


import React, { useState, useEffect } from "react";
import "../style/create.css";
import { postWithoutTokenAPI } from "../util/Api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

const CreateAccount = () => {
    const navigate = useNavigate();
    const [phonenumber, setPhonenumber] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [error, setError] = useState("");
    const login = useSelector((state) => state.auth?.auth?.access_token);

    // Validate Kenya phone number: must be 9 digits only
    const validateKenyaNumber = (number) => /^[0-9]{9}$/.test(number);

    const handleSubmit = async () => {
        setError("");

        if (!phonenumber) {
            setError("Phone number is required");
            return;
        }

        if (!validateKenyaNumber(phonenumber)) {
            setError("Enter a valid 9-digit Kenyan phone number");
            return;
        }

        if (!termsAccepted) {
            setError("You must accept the terms and conditions");
            return;
        }

        const fullPhoneNumber = `+254${phonenumber}`;

        try {
            const response = await postWithoutTokenAPI("/auth/otpsend", {
                phone_number: fullPhoneNumber,
                role:"user"
            });

            if (response.statusCode === 200) {
                toast.success("OTP sent successfully!");
                setTimeout(() => {
                    navigate("/Verify", {
                        state: {
                            phone_number: fullPhoneNumber,
                            fromForgotPassword: false,
                        },
                    });
                }, 2000);
            } else {
                setError(response.message || "Request failed.");
            }
        } catch (err) {
            setError("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        if (login) {
            navigate('/user');
        }
    }, [login, navigate]);

    return (
        <>
            {!login &&
                <div className="auth-box">
                    <ToastContainer autoClose={10000} />
                    <h2 className="auth-title">Create Account</h2>

                  <div className="auth-field phone-field d-flex gap-2">
  <div className="country-code  d-flex gap-2 justify-content-center align-items-center">
    <img
      src="https://flagcdn.com/w40/ke.png" 
      alt="Kenya Flag"
      className="flag-icon"
      style={{width:"20px",height:"20px"}}
    />
    +254
  </div>
  <input
    className="auth-input"
    type="text"
    placeholder="712345678"
    value={phonenumber}
    onChange={(e) => {
      const value = e.target.value.replace(/\D/g, '');
      if (value.length <= 9) {
        setPhonenumber(value);
      }
    }}
  />
</div>


                    <div className="auth-links">
                        <div className="auth-remember-section">
                            <input
                                type="checkbox"
                                id="remember"
                                checked={termsAccepted}
                                onChange={(e) => setTermsAccepted(e.target.checked)}
                            />
                            <label htmlFor="remember" className="auth-remember-label">
                                I accept all <a href='/terms' target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                            </label>
                        </div>
                    </div>

                    {error && <div className="auth-error">{error}</div>}

                    <button className="auth-button" onClick={handleSubmit}>
                        Create Account
                    </button>

                    <div className="auth-signup-link">
                        <span>Already have an account?</span>
                        <a href="/login">Login</a>
                    </div>
                </div>
            }
        </>
    );
};

export default CreateAccount;

